//const prayers = require("/src/assets/prayers.json");
import {format, isSameDay} from 'date-fns';
import {appHost} from "./constants.js";

let host = appHost;

export default {
	async getPrayers(clientId){

		let res = await fetch(`${host}/wall-api/walls/${clientId}/prayers`);
		let results = await res.json();

		results.forEach(result => {
			result.wallId = clientId;
		})

		return results;
	},

	async getAdminPrayers(clientId, jwtToken){
		let res = await fetch(`${host}/admin-api/walls/${clientId}/prayers`, {headers:{Authorization: jwtToken}});

		let results = await res.json();

		results.forEach(result => {
			result.wallId = clientId;
		})

		return results;
	},

	async setPrayer(clientId, prayerId){


		try{
			await fetch(`${host}/wall-api/walls/${clientId}/prayers/${prayerId}/prayFor`, {method: "POST"});
		}catch(e){
			return false;
		}
		return true;
	},

	async deletePrayer(clientId, prayerId, jwtToken){
		try{
			let res = await fetch(`${host}/admin-api/walls/${clientId}/prayers/${prayerId}`, {method: "DELETE", headers:{Authorization: jwtToken}})

			if(res.status == 500){
				return false;
			}

		}catch(e){
			return false;
		}


		return true;
	},

	async getWalls(userId, jwtToken){
		try{
			let res = await fetch(`${host}/admin-api/users/${userId}/walls`, {headers: {Authorization: jwtToken}});
			return await res.json();
		}catch(e){
			console.log(e);
			return [];
		}
	},

	async postWall(userId, wallId, jwtToken){
		try{
			await fetch(`${host}/admin-api/users/${userId}/walls`, {method: "POST", headers: {Authorization: jwtToken}, body: JSON.stringify({
				wallId: wallId
			})});
		}catch(e){
			console.log(e);
			return false;
		}
	},

	async submitPrayer({client, name, prayer, captchaToken, isPrivate=false}){
		try{
			await fetch(`${host}/wall-api/walls/${client}/prayers`, {method: "POST", body: JSON.stringify({
				content: name ? `${prayer} - ${name}` : prayer,
				captchaToken: captchaToken,
				isPrivate: isPrivate
			})})
		}catch(e){
			console.log(e);
		}
	},

	preparePrayers(prayers){
		let sortedPrayers = prayers.sort((a,b)=>{
			return b.time-a.time;
		});


		let lastDate = new Date(0);
		sortedPrayers.forEach(prayer => {
			let prayerDate = new Date(Number(prayer.time));
			prayer.legibleDate = format(prayerDate, "MMM dd");

			prayer.visDate= !isSameDay(lastDate, prayerDate)
			lastDate = prayerDate;

		});

		return sortedPrayers;
	}
}